package ru.it_mozaika.sender.common.httpClient

import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.compression.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.serialization.kotlinx.json.*
import ru.it_mozaika.sender.common.models.httpApiJson

val client: HttpClient by lazy {
    HttpClient {
        followRedirects = true
        expectSuccess = false
        install(ContentNegotiation) {
            json(httpApiJson)
        }
        install(WebSockets)

        install(HttpTimeout) {
            connectTimeoutMillis = 10_000L
            requestTimeoutMillis = 10_000L
            socketTimeoutMillis = 10_000L
        }
        install(ContentEncoding) {
            gzip()
        }

    }
}